import Image from "apps/website/components/base/Image/Image";
import Spacer from "apps/website/components/layout/Spacer/Spacer";
import { IStoryBlokComponent } from "apps/website/components/page/api.types";
import {
  Animation,
  animations,
} from "apps/website/components/section/SectionAnimatedSplit/SectionAnimatedSplit.map";

const DEFAULT_ANIMATION: Animation = "munchAndSnooze";

export interface IStoryBlokArticleDivider {
  animation: Animation;
}

export const StoryBlokArticleDivider = ({ blok }: IStoryBlokComponent<IStoryBlokArticleDivider>) => {
  const animation = animations[blok.animation] ? blok.animation : DEFAULT_ANIMATION;

  return (
    <>
      <div data-component="StoryBlokArticleDivider" className="relative overflow-hidden">
        <div className="absolute w-full h-full bg-repeat-x bg-center bg-[url('/images/sections/animated-split/split-line.webp')]"></div>
        <div className="relative">
          <Image
            image={{
              src: animations[animation].src,
              width: animations[animation].width,
              height: animations[animation].height,
            }}
            alt=""
          />
        </div>
      </div>
      <Spacer size="xl" />
    </>
  );
};
